import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { VenueMenu } from "sweet-global";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import { ItemLabel, ItemTitle } from "sweet-web/components/universal/Text";
import { colors } from "sweet-web/lib/styles";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  min-width: 300px;
  &:hover {
    cursor: default;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-right: 10px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-left: 10px;
`;

type Props = {
  menuId: string;
  menuEntity: VenueMenu;
  onEdit: () => void;
  onRemove: () => void;
};

const MenuLine: React.FC<Props> = props => {
  const [menu, setMenu] = useState(props.menuEntity);

  useEffect(() => {
    setMenu(props.menuEntity);
  }, [props.menuEntity]);

  return (
    <Wrapper onClick={() => props.onEdit()}>
      <Left>
        <ItemTitle style={{ color: colors.primary, margin: 0 }}>
          {menu.name}
        </ItemTitle>
        <ItemLabel style={{ margin: 0 }}>
          {menu.type.charAt(0).toUpperCase() + menu.type.slice(1).toLowerCase()}{" "}
          Menu
        </ItemLabel>
      </Left>
      <Buttons>
        <OutlineButton
          color="gray"
          title="Edit"
          style={{ marginRight: 10 }}
          onClick={() => props.onEdit()}
        />
        <OutlineButton
          color="gray"
          title="Remove"
          onClick={() => props.onRemove()}
        />
      </Buttons>
    </Wrapper>
  );
};

export default MenuLine;
